import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Star, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function Stars({ n }) {
  return <div className="flex gap-0.5">{[1, 2, 3, 4, 5].map((i) => (
    <Star key={i} className={`w-4 h-4 ${i <= n ? "fill-amber-400 text-amber-400" : "text-slate-300"}`} />))}</div>;
}

export default function ReviewWidget() {
  const { subId } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API}/public/reviews/${subId}/widget`).then(({ data }) => setData(data)).catch(() => setData(false));
  }, [subId]);

  if (data === null) return <div className="min-h-screen flex items-center justify-center bg-white"><Loader2 className="w-6 h-6 animate-spin text-slate-400" /></div>;
  if (data === false) return <div className="min-h-screen flex items-center justify-center bg-white text-slate-400 text-sm">Reviews unavailable.</div>;

  const color = data.brand?.color || "#6366F1";
  const s = data.summary;

  return (
    <div className="min-h-screen bg-white p-5" data-testid="review-widget">
      <div className="max-w-xl mx-auto">
        <div className="flex items-center gap-3 pb-4 border-b border-slate-100">
          <div className="text-3xl font-bold text-slate-900">{s.average || "—"}</div>
          <div><Stars n={Math.round(s.average)} /><p className="text-xs text-slate-400 mt-0.5">{s.public_count} reviews</p></div>
          <div className="ml-auto text-sm font-semibold" style={{ color }}>{data.brand?.name}</div>
        </div>
        <div className="divide-y divide-slate-100">
          {data.reviews.length === 0 && <p className="py-10 text-center text-slate-400 text-sm" data-testid="widget-empty">No reviews yet.</p>}
          {data.reviews.map((r, i) => (
            <div key={i} className="py-4" data-testid={`widget-review-${i}`}>
              <div className="flex items-center gap-2">
                <Stars n={r.rating} />
                <span className="text-sm font-medium text-slate-800">{r.name}</span>
                {r.featured && <Star className="w-3.5 h-3.5 fill-amber-400 text-amber-400" />}
              </div>
              {r.comment && <p className="text-sm text-slate-600 mt-1.5">{r.comment}</p>}
              <p className="text-[11px] text-slate-400 mt-1">{new Date(r.created_at).toLocaleDateString()}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
